const Card = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      data-testid="card"
      className={`rounded-l border border-gray-300 p-4 shadow-md ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
